module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-map"
  }, [_c('ul', {
    staticClass: "m-map__options list-unstyled"
  }, [_c('li', [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showParksMarkers),
      expression: "showParksMarkers"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showParksMarkers) ? _vm._i(_vm.showParksMarkers, null) > -1 : (_vm.showParksMarkers)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showParksMarkers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showParksMarkers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showParksMarkers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showParksMarkers = $$c
        }
      }, _vm.onLayerSelectionChange]
    }
  }), _vm._v(" " + _vm._s(_vm.$t('content.tecnoparks')) + "\n        ")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showCompaniesMarkers),
      expression: "showCompaniesMarkers"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showCompaniesMarkers) ? _vm._i(_vm.showCompaniesMarkers, null) > -1 : (_vm.showCompaniesMarkers)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showCompaniesMarkers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showCompaniesMarkers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showCompaniesMarkers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showCompaniesMarkers = $$c
        }
      }, _vm.onLayerSelectionChange]
    }
  }), _vm._v(" " + _vm._s(_vm.$t('commons.companies')) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    ref: "mapContainer",
    staticClass: "m-map__canvas",
    style: (_vm.mapCanvasStyle)
  }), _vm._v(" "), (_vm.hasActiveLayer) ? _c('div', {
    staticClass: "m-map__legend"
  }, [_c('strong', [_vm._v(_vm._s(_vm.legendTitle))]), _vm._v(" "), _c('span', {
    staticClass: "m-map__legend-year"
  }, [_vm._v(_vm._s(_vm.currentYear))]), _vm._v(" "), _c('div', {
    staticClass: "m-map__legend-scale"
  }, [_c('span', {
    staticClass: "m-map__legend-min"
  }, [_vm._v("0")]), _vm._v(" "), _c('span', {
    staticClass: "m-map__legend-gradient",
    style: (_vm.legendGradientStyle)
  }), _vm._v(" "), _c('span', {
    staticClass: "m-map__legend-max"
  }, [_vm._v(_vm._s(_vm.maxStateCount))])]), _vm._v(" "), (_vm.showParksMarkers && _vm.showCompaniesMarkers) ? _c('div', {
    staticClass: "m-map__legend-hint"
  }, [_c('span', {
    staticClass: "m-map__legend-dot m-map__legend-dot--parks"
  }), _vm._v(" " + _vm._s(_vm.$t('content.tecnoparks')) + "\n      "), _c('span', {
    staticClass: "m-map__legend-dot m-map__legend-dot--companies"
  }), _vm._v(" " + _vm._s(_vm.$t('commons.companies')) + "\n    ")]) : _vm._e()]) : _c('p', {
    staticClass: "m-map__legend m-map__legend--empty"
  }, [_vm._v(_vm._s(_vm.$t('content.mapLegendEmpty')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2702c22a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portal/Map.vue
// module id = 705
// module chunks = 1